/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — FormFooter layout component
 */
import cx from 'classnames';
import * as React from 'react';

import './FormFooter.less';

export interface FormFooterProps {
  /** Start-aligned slot — secondary actions (e.g. Back button). Optional. */
  start?: React.ReactNode;
  /** End-aligned slot — primary actions (e.g. Save button). Required. */
  end: React.ReactNode;
  className?: string;
}

const FormFooter: React.FC<FormFooterProps> = ({ start, end, className }) => (
  <div className={cx('ds-form-footer', className)}>
    <div className="ds-form-footer__start">{start}</div>
    <div className="ds-form-footer__end">{end}</div>
  </div>
);

FormFooter.displayName = 'FormFooter';

export { FormFooter };
export default FormFooter;
